const SortOrder = {
  ASC: 'ASC',
  DESC: 'DESC'
};

export default SortOrder;



// WEBPACK FOOTER //
// ./src/types/SortOrder.js